// A render-time predicate for SignaalitList: narrows which rows are rendered while the
// full `sources` array stays intact for connection-source history resolution.
//
// An absent filter (undefined) means "show everything" — today's behaviour is preserved.
// Present: only rows whose source_id appears in the filter render. An entry without `names`
// means "all of this source's rows"; an entry with `names` narrows further to those names.
export type VisibleSignalFilter = Array<{
  source_id: string;
  names?: string[];
}>;

export function is_row_visible(
  source_id: string,
  name: string,
  filter: VisibleSignalFilter | undefined,
): boolean {
  if (!filter) return true;
  const entry = filter.find((e) => e.source_id === source_id);
  if (!entry) return false;
  if (!entry.names) return true;
  return entry.names.includes(name);
}
